module.exports = __webpack_public_path__ + "img/44.912dd2fc.png";